import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "../hooks/useAuth";
import { useCurrentUserRole } from "../hooks/useCurrentUserRole";
import { useGovernanceActorProfile } from "../hooks/useGovernanceActorProfile";
import { mayManageTenantUsers } from "../lib/tenantUserAccess";

/**
 * Route guard: tenant user management is only for tenant_admin, or super_admin with explicit switched tenant.
 */
export function TenantGovernanceRoute() {
  const { session, user, loading: authLoading } = useAuth();
  const actorId = session?.user?.id ?? user?.id;
  const { role, isLoading: roleLoading, isError: roleError } = useCurrentUserRole(actorId);
  const { profile, isLoading: profileLoading, isError: profileError } = useGovernanceActorProfile(actorId);

  if (authLoading || roleLoading || profileLoading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center text-sm text-muted-foreground">Laden...</div>
    );
  }
  if (roleError || profileError) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center text-sm text-red-600">
        Kon gegevens niet laden. Controleer of dit account geldig is.
      </div>
    );
  }
  if (!mayManageTenantUsers(role, profile)) {
    return <Navigate to="/app/explorer" replace />;
  }

  return <Outlet />;
}
